"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = void 0;
const getToStringValue = (data) => Object.prototype.toString.call(data).toLowerCase();
const isObject = (data) => getToStringValue(data) === '[object object]';
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map